export const SEARCH_TERM = "term";
